const brandColor                    = "#56d43d";
const brandColorHover               = "#5fe545";

const textPrimary                   = "#ffffff";
const textSecondary                 = "#cccccc";
const textTertiary                  = "#78829d";
const textQuaternary                = "#78829d90";

//const textPrimaryHover              = "#ffffff";
const textSecondaryHover            = "#ffffff";
const textTertiaryHover             = "#cccccc";
const textQuaternaryHover           = "#78829d";

const textPrimaryDisabled           = "#78829d50";

const textOppositePrimary           = "#10233b";
const textOppositeSecondary         = "#041127";

const textInlineLink                = "#5e8e62";
const textInlineLinkHover           = brandColor;

const cardPrimary                   = "#10233b";
const cardSecondary                 = "#041127";
const cardTertiary                  = "#192d47";

const cardPrimaryAlpha              = "#10233b50";
//const cardSecondaryAlpha            = "#04112750";
//const cardTertiaryAlpha             = "#192d4750";

const cardPrimaryHover              = "#0D1D30";
//const cardSecondaryHover            = "#041127";
const cardTertiaryHover             = "#192d47";

const primaryBoxShadow              = "0px 0px 20px 0px rgba(0, 12, 36, 2.15)";
const separatorPrimary              = "1px solid #2b3954";
const separatorSecondary            = "1px solid #FFFFFF10";
const tooltipBackground             = "#041127";
const tickerBackground              = "#13253C90";
const skeletonHighlight             = "#132841";
const bodyBackground                = "#000c24";
const borderRadius                  = "0.375rem";

const transitionPrimaryProperty     = "all";
const transitionPrimaryDuration     = "750ms";
const transitionPrimaryTiming       = "cubic-bezier(0.075, 0.82, 0.165, 1)";

export const lightTheme = {
    
  content__width                    : "1468px",
  brand__primary                    : brandColor,
  text__primary                     : textSecondary,
  title__primary                    : textPrimary,
  card__primary                     : cardPrimary,
  card__secondary                   : cardSecondary,
  card__tertiary                    : cardTertiary,
  separator_primary                 : separatorPrimary,
  separator_secondary               : separatorSecondary,
  tooltip__background_primary       : tooltipBackground,

  skeleton__highlight               : skeletonHighlight,

  body__background                  : bodyBackground,
  border__radius                    : borderRadius,
  box__shadow                       : primaryBoxShadow,

  transition__property              : transitionPrimaryProperty,
  transition__duration              : transitionPrimaryDuration,
  transition__timing                : transitionPrimaryTiming,

  box        : {
    title   : {
      color                         : textPrimary
    },
    search  : {
      color                         : textSecondary,
      placeholder                   : textTertiary,
      input__bottom_border          : separatorSecondary
    }
  },

  socials        : {
    icon  : {
      color                         : textTertiary,
      hover   : {
        color                       : brandColor
      }
    }
  },

  link    : {
    color                           : textTertiary,
    hover     : {
      color                         : textTertiaryHover
    }
  },

  text    : {
    color                           : textSecondary
  },

  inline__link    : {
    text    : {
      color                         : textInlineLink,
      text__decoration              : "none",
      hover     : {
        color                       : textInlineLinkHover,
        text__decoration            : "underline"
      }
    }
  },

  /**
   * BULUNAMADI KUTULARI
   */
  not__found  : {
    background  : {
      color                         : cardPrimaryAlpha
    },
    text        : {
      color                         : textTertiary
    }
  },

  promotions__item: {
    
  },
  
  /**
   * KAZANANLAR KUTUSU
   */
  winners__item: {
    border                          : "2px solid " + brandColor + "00",
    background  : {
      color                         : cardTertiary
    },
    username  : {
      text    : {
        color                       : textSecondary
      }
    },
    game  : {
      text    : {
        color                       : textTertiary
      }
    },
    amount    : {
      text    : {
        color                       : brandColor
      }
    },
    hover     : {
      background  : {
        color                       : cardTertiaryHover              
      },
      border                        : "2px solid " + brandColor,
      transform                     : "scale(0.975)"
    }
  },

  /**
   * OYUN SAĞLAYICILARI MENÜSÜ
   */
  game__providers: {
    background: {
      color                         : cardPrimaryAlpha
    },
    reset: {
      text: {
        color                       : textOppositeSecondary
      },
      background: {
        color                       : brandColor
      },
      hover:{
        text: {
          color                     : textOppositeSecondary
        },
        background:{
          color                     : brandColorHover
        }
      },
      disabled:{
        text: {
          color                     : textPrimaryDisabled
        },
        background:{
          color                     : cardPrimary
        }
      }
    },
    selected__providers: {
      text: {
        color                       : textSecondary
      },
      background: {
        color                       : cardPrimary
      }
    }
  },

  /**
   * OYUN KATEGORİLERİ CAROUSEL'İ
   */
  game__categories: {
    item    : {
      text            : {
        color                       : textSecondary,
      },
      background      : {
        color                       : cardPrimary,
      },
      hover           : {
        text            : {
          color                     : textSecondaryHover,
        },
        background  : {
          color                     : cardPrimaryHover
        }
      },
      selected        : {
        background  : {
          color                     : brandColor
        }
      }
    }
  },

  /**
   * NEREDEYSE TÜM OYUN KUTULARI
   */
  game__box: {
    tooltip   : {
      box__shadow                   : primaryBoxShadow,
      text    : {
        color                       : textOppositePrimary
      },
      background  : {
        color                       : brandColor,
      }
    },
    hover     : {
      outline                       : "2px solid " + brandColor
    }
  },

  /**
   * POPOVERLAR
   */
  popover     : {
    background                      : cardPrimary,
    box__shadow                     : "0px 0px 50px 0px rgba(0, 12, 36, 2.15)",
    separator                       : separatorPrimary,
    username                        : brandColor,
    description                     : "#98A1B7"
  },

  /**
   * GİRİŞ YAPMIŞ KULLANICI POPOVER MENÜSÜ
   */
  login__user_profile_popover : {
    picture   : {
      hover: {
        border                      : "1.5px solid " + brandColor,
      }
    }
  },
  
  /**
   * YENİ VERSİYON
   */
  new__version: {
    title   : {
      color: brandColor
    },
    text: {
      color: textTertiary
    },
    background: {
      color: cardPrimary
    }
  },

  /**
   * PROMOTIONS
   */
  promotions      : {
    tab__menu: {
      box: {
        description: {
          background: {
            color                   : cardPrimaryAlpha
          },
          text: {
            color                   : textTertiary
          }
        }
      },
      item: {
        background: {
          color                     : cardPrimaryAlpha
        },
        text: {
          color                     : textTertiary
        },
        hover: {
          background: {
            color                     : cardPrimary
          },
          text: {
            color                     : textSecondary
          }
        },
        selected: {
          background: {
            color                     : brandColor
          },
          text: {
            color                     : textOppositeSecondary
          }
        }
      }
    }
  },

  /**
   * HEADER MENÜSÜ
   */
  header      : {
    border                          : "none",
    outline                         : "none",
    border__radius                  : "0px 0px 0.375rem 0.375rem",
    background                      : cardSecondary,
    separator : {
      border                        : separatorPrimary
    },
    ticker       : {
      border__radius                : "0.25rem",
      text    : {
        color                       : textSecondary
      },
      background  : {
        color                       : tickerBackground
      },
    },
    menu      : {
      padding                       : "0",
      margin                        : "0",
      border                        : "none",
      outline                       : "none",
      border__radius                : "0px 0px .5rem .5rem",
      background  : {
        color                       : cardPrimary
      },
      item: {
        text: {
          color                     : textSecondary
        },
        background                  : {
          color                     : cardPrimary
        },
        icon: {
          color                     : textSecondary
        },
        hover: {
          text: {
            color                   : brandColor
          },
          icon: {
            color                   : brandColor,
          },
          background: {
            color                   : "#00000030" 
          }
        }
      }
    }
  },

  /**
   * FOOTER
   */
  footer      : {
    sitemap   : {
      title   : {
        color                       : brandColor
      },
      link    : {
        color                       : textTertiary,
        hover     : {
          color                     : textTertiaryHover
        }
      }
    },
    licenses  : {
      color                         : textQuaternary,
      hover: {
        color                       : textQuaternaryHover
      }
    },
    provider__info    : {
      copyright   : {
        text  : {
          color                     : textTertiary,
        },
        link  : {
          color                     : textSecondary,
          hover         : {
            color                   : brandColor
          }
        }
      },
      link  : {
        color                       : textTertiary,
        hover         : {
          color                     : brandColor
        }
      }
    }

  },

  /**
   * MODAL'LAR
   */
  modal   : {
    subtitle   : {
      text  : {
        color                       : brandColor
      }
    },
    description   : {
      text  : {
        color                       : textSecondary
      }
    }
  }

}